import React, {
    Fragment,
    useEffect,
    useRef
} from "react";
import { connect } from "react-redux";
import {
    Button,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label
} from "reactstrap";
import Message from "../../CommonData/Data/Message.js";
import VWLoading from "../../components/vwLoading/vwLoading.js";
import {
    clearSubmitReturnApprovalActionError,
    setReturnApprovalsForm,
    submitReturnApprovalAction
} from "../../store/returnApprovals/actions.js";


const ApproveOrRejectReturn = (props) => {
    const { returnApprovalsForm, returnStatus, errorMessage, handleClose, isPending } = props;
    const { Comments, errors } = returnApprovalsForm || {};
    const textareaRef = useRef(null);

    useEffect(() => {
        props.setReturnApprovalsForm({
            errors: {}
        })
        props.clearSubmitReturnApprovalActionError();
        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const validateOnChange = (event) => {
        const { name, value } = event.target;
        props.setReturnApprovalsForm(
            {
                ...returnApprovalsForm,
                [name]: value,
                errors: {
                    ...returnApprovalsForm.errors,
                    [name]: null,
                }
            })
        autoResize();
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            props.setReturnApprovalsForm(
                {
                    ...returnApprovalsForm,
                    Comments: (returnApprovalsForm && returnApprovalsForm.Comments) ? returnApprovalsForm.Comments + "\n" : "\n",
                    errors: {
                        ...returnApprovalsForm.errors,
                        Comments: null,
                    }
                })
            autoResize();
        }
    };

    const autoResize = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const { returnStatus, requestId } = props;
        const { Comments } = returnApprovalsForm || {};
        let currentErrors = {};
        if (!Comments) {
            currentErrors.Comments = "Reason is required"
        }
        props.setReturnApprovalsForm(
            {
                ...returnApprovalsForm,
                errors: currentErrors
            })
        if (Object.keys(currentErrors).length === 0) {
            props.submitReturnApprovalAction(returnStatus, requestId);
        }
    };

    return isPending ? (<VWLoading />) : (
        <Fragment>
            {errorMessage && (
                <Message
                    type="danger"
                    defaultMessage={errorMessage}
                    baseClassName="alert"
                />
            )}
            <Form className="mb-3" name="formApprovalAction" onSubmit={handleSubmit}>
                <FormGroup>
                    <Label>
                        {returnStatus === "Approved" ? "Approval Reason" : "Rejection Reason"}<span className="text-danger">*</span>
                    </Label>
                    <Input
                        innerRef={textareaRef}
                        type="textarea"
                        name="Comments"
                        placeholder="Enter reason"
                        onChange={validateOnChange}
                        value={Comments || ""}
                        invalid={errors && errors.Comments}
                        autoFocus
                        rows={1}
                        onKeyDown={handleKeyDown}
                        style={{
                            minHeight: "30px",
                            resize: "none",
                            overflow: "hidden",
                        }}
                    />
                    <FormFeedback>{errors && errors.Comments}</FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Button
                        type="submit"
                        className='me-4'
                        color="success"
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                    <Button
                        color="danger"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </FormGroup>
            </Form>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    returnStatus: state.returnApprovals.action,
    requestId: state.returnApprovals.selectedId,
    returnApprovalsForm: state.returnApprovals.returnApprovalsForm,
    errorMessage: state.returnApprovals.errorMessage,
    isPending: state.returnApprovals.isPending
});

const mapDispatchToProps = (dispatch) => ({
    setReturnApprovalsForm: (approvalsForm) => dispatch(setReturnApprovalsForm(approvalsForm)),
    submitReturnApprovalAction: (returnStatus, requestId) => dispatch(submitReturnApprovalAction(returnStatus, requestId)),
    clearSubmitReturnApprovalActionError: () => dispatch(clearSubmitReturnApprovalActionError())
});

export default connect(mapStateToProps, mapDispatchToProps)(ApproveOrRejectReturn);
